import React from 'react'
import { useRouter } from 'next/router'
import { prefixLocale } from '@helpers/env'
import { ProductColor } from 'types/product'
import SwatchColor, { SwatchColorProps } from '@components/ui/SwatchColor'
import styles from './styles.module.scss'

type ProductSwatchColorProps = {
  onSelect: (colorName: SwatchColorProps['colorName']) => void
  color: ProductColor
  colorName: SwatchColorProps['colorName']
  productHandle: string
  active: SwatchColorProps['active']
  isOutOfStock?: SwatchColorProps['isUnavailable']
}

const ProductSwatchColor = ({
  onSelect,
  colorName,
  color,
  active,
  productHandle,
  isOutOfStock = false
}: ProductSwatchColorProps) => {
  const router = useRouter()
  const { image, primary, secondary } = color || {}
  const url = `${prefixLocale()}${router.route.replace(
    '/[productHandle]',
    ''
  )}/${productHandle}`

  const handleOnClick = (ev: React.MouseEvent<HTMLAnchorElement>) => {
    ev.preventDefault()
    onSelect(colorName)
  }

  if (!primary) return null

  return (
    <a
      className={`${styles.colors__item} colors-item${
        active ? ' colors-item-selected' : ''
      }`}
      href={url}
      data-testid={`SwatchColor${active ? '-selected' : ''}`}
      onClick={handleOnClick}
    >
      <SwatchColor
        colorName={colorName}
        primary={primary}
        secondary={secondary}
        image={image}
        size="small"
        active={active}
        isUnavailable={isOutOfStock}
      />
    </a>
  )
}

export default ProductSwatchColor
